// Duplicate from common-components, but without any endpoint calls
import React from "react";
import PropTypes from "prop-types";
import { Popover } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";

export const AdminGroup = ({ selectedGroup }) => {
  const groupContent = () => (
    <>
      <div>Identifier: {selectedGroup.groupIdentifier}</div>
      <div>Description: {selectedGroup.description}</div>
    </>
  );

  const groupTrigger = () => (
    <span style={{ cursor: "pointer" }}>{selectedGroup.displayName}</span>
  );

  const groupHeader = () => (
    <h3>
      <UsergroupAddOutlined /> {selectedGroup.displayName}
    </h3>
  );

  return (
    <Popover
      key={selectedGroup.id}
      content={groupContent()}
      title={groupHeader()}
    >
      {groupTrigger()}
    </Popover>
  );
};

AdminGroup.propTypes = {
  selectedGroup: PropTypes.object.isRequired,
};
